import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { Box, styled } from '@mui/material';
import { forwardRef, useImperativeHandle, useRef } from 'react'; // Добавить forwardRef

const SimpleBarStyle = styled(SimpleBar)(() => ({
  maxHeight: '100%',
  '.simplebar-scrollbar:before': { backgroundColor: '#2e2d348f' }
}));

const Scrollbar = forwardRef(({ children, sx, alsoMobile, ...other }, ref) => {
  // Обернуть в forwardRef
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  const simpleBarRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      scrollToBottom: () => {
        if (simpleBarRef.current) {
          const scrollElement = simpleBarRef.current.getScrollElement();
          if (scrollElement) {
            scrollElement.scrollTo({
              top: scrollElement.scrollHeight,
              behavior: 'smooth'
            });
          }
        }
      },
      getScrollElement: () => {
        return simpleBarRef.current?.getScrollElement();
      }
    }),
    []
  );

  if (isMobile && !alsoMobile) {
    return <Box sx={{ overflowX: 'auto' }}>{children}</Box>;
  }

  return (
    <SimpleBarStyle sx={sx} {...other} ref={simpleBarRef}>
      {' '}
      {/* Добавить ref */}
      {children}
    </SimpleBarStyle>
  );
});

Scrollbar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  alsoMobile: PropTypes.bool // Исправить тип
};

Scrollbar.displayName = 'Scrollbar'; // Добавить для отладки

export default Scrollbar;
